/**
 * Account types for tax ID validation
 * Based on backend requirements from FF-4166
 */
export enum AccountType {
  Individual = 0,
  Entity = 1,
  EntityIndividual = 2,
}

export interface FormIntlTaxIdInputProps {
  /**
   * Field name for the tax ID number input
   */
  taxIdFieldName: string;

  /**
   * Field name for the tax country selection
   */
  taxCountryFieldName: string;

  /**
   * Label for the tax ID section
   */
  label?: string;

  /**
   * Whether the tax ID is optional
   */
  optional?: boolean;

  /**
   * Placeholder text for the tax ID number input
   */
  placeholder?: string;

  /**
   * Additional CSS class name
   */
  className?: string;

  /**
   * Account type for validation - determines which tax ID formats are allowed
   * For US entities, only EIN format is accepted when accountType is Entity
   */
  accountType?: AccountType;

  /**
   * Skip validation entirely (for testing or special cases)
   */
  skipValidation?: boolean;

  /**
   * Whether or not to display the formik field validation error message on validation.
   * @default true (at component level, show the validation error message)
   */
  displayErrorMessage?: boolean;
}
